import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

export const config = {
	apiKey: "AIzaSyCpHoMf7RI9lHw11r4gYZ_fDJ_28kWqFxE",
	authDomain: "com1024holdings.firebaseapp.com",
	projectId: "com1024holdings",
	storageBucket: "com1024holdings.firebasestorage.app",
	messagingSenderId: "202091917131",
	appId: "1:202091917131:web:b6b6b3528cf3c39fd982ce",
	measurementId: "G-H7YFE6DLY7",
};

export const app = initializeApp(config);
export const auth = getAuth(app);
